import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {FormComponent} from '@ngx-ivengi/crud';
import {ProductService} from './product.service';
import {Product} from './product.model';
import {EnumerationService} from '../enumeration/enumeration.service';
import {EnumerationInterface} from '../enumeration/enumeration.interface';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html'
})
export class ProductFormComponent extends FormComponent implements OnInit {

  public product: Product = new Product();
  public productGroup: string;
  public productGroups: EnumerationInterface;
  public formTitle: string;
  public stateIdParam: string = 'productId';

  constructor(
    private productService: ProductService,
    private enumerationService: EnumerationService,
    protected router: UIRouter
  ) {
    super(router);

    this.enumerationService.get('product-group').subscribe((productGroups: EnumerationInterface) => {
      this.productGroups = productGroups;
    });
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.formTitle = 'Product toevoegen';
      } break;

      case this.FormMode.UPDATE: {
        this.formTitle = 'Product gegevens';
        this.productService.get(this.router.stateService.params[this.stateIdParam]).subscribe((product: Product) => {
          this.product = product;
        });
      } break;
    }
  }

  public save(): void {

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.productService.add(this.product).subscribe((result) => {
          this.router.stateService.go('management.product', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.productService.update(this.product).subscribe((result) => {
          this.router.stateService.go('management.product', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product-form.component.ts